import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { Backend } from '@dentalux/i18next-plugins'

import enTranslations from './i18n/en.json'
import deTranslations from './i18n/de.json'

const shouldUsePreview = ['development', 'preview'].includes(process.env.REACT_APP_ENV || '')

const setupTranslations = (language: string): Promise<typeof i18n> => {
  const instance = i18n.createInstance({
    backend: {
      applicationName: 'availy',
      fallbackResource: {
        en: enTranslations,
        de: deTranslations,
      },
      contentfulConfig: {
        usePreview: shouldUsePreview,
      },
    },
    lng: language,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
  })

  return new Promise((resolve) => {
    instance
      .use(initReactI18next) // passes i18n down to react-i18next
      .use(Backend)
      .init(() => {
        resolve(instance)
      })
  })
}

export default setupTranslations
